
import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthConfig, OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';
import { filter } from 'rxjs/operators';
import { IndexService } from '../index.service';

const authConfig: AuthConfig = {
  issuer: "https://accounts.google.com",
  strictDiscoveryDocumentValidation: false,
  clientId: "68528419432-mb4ovgbbfah7g5o46fmj3a5et1q26odv.apps.googleusercontent.com",
  redirectUri: window.location.origin + "/public/verification",
  scope: "openid profile email",
  //showDebugInformation: true,

  // useSilentRefresh: true,
  // silentRefreshTimeout: 5000,
  // timeoutFactor: 0.75,
  // sessionChecksEnabled: true,
  // clearHashAfterLogin: false,
}

@Injectable({
  providedIn: 'root',
})
export class AuthGoogleService {

  constructor(private oauthService: OAuthService,
    private _router: Router
  ) {
    this.oauthService.configure(authConfig);
    this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }

  initLogin() {
    // Inicia el flujo de inicio de sesión
    this.oauthService.initLoginFlow();
  }

  logout() {
    try {
      if (this.isTokenValid()) {
        // Revoca el token y cierra sesión
        this.oauthService.revokeTokenAndLogout();
      }
    } catch (e) { }
    this.clearLocalStorage();
    this._router.navigate(['/']);
  }

  clearLocalStorage() {
    // Limpia cualquier dato relacionado con la autenticación del almacenamiento local
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('id_token');
  }

  async getToken() {
    // Obtiene el ID token actual
    return this.oauthService.getIdToken();
  }

  private isTokenValid(): boolean {
    const accessToken = this.oauthService.getAccessToken();
    return !!accessToken && this.oauthService.hasValidAccessToken();
  }

}